import { FC } from 'react';
import React from 'react';

export const Env: FC = () => {
    return (
        <div>
            <div> 
                <iframe 
                title="Slide" 
                src="https://docs.google.com/presentation/d/e/2PACX-1vSgFIn5I-bSu5P-ZfQEVKLFCK_25RDK3IFOZEdMnY88ouR2SoX5jtDXO9BSyfT1W-Wd2VO6Vrh5SPAk/embed?start=false&loop=false&delayms=60000" allowFullScreen 
                width="1200" height="675">

                 </iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};
